import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SecurityResultStatus } from 'src/app/clients/system-api/SystemApiClient';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  emailFormSendCodeForm!: FormGroup;
  loading = false;
  submitted = false;
  email!: string;
  userId!: number;
  isEmailPresent = false
  TransLang: string[] = [];

  constructor(private router: Router,
    public userService: UserService,
    private _snackBarService: SnackBarService,
    private translate: TranslateService,
    private formBuilder: FormBuilder,) {
    translate.setDefaultLang('mk');
    translate.addLangs(['mk', 'al']);
  }

  ngOnInit(): void {
    this.emailFormSendCodeForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
    });
    this.getTransLanguage();
  }

  get f() { return this.emailFormSendCodeForm.controls; }

  getTransLanguage() {
    this.TransLang = [...this.translate.getLangs()];
  }

  onSubmit() {
    this.submitted = true;

    this.userService.generateResetPasswordCode(this.email).subscribe((data) => {
      this._snackBarService.callSnackBar(data.status, "EmailVerificationCode");
      if (data.status == SecurityResultStatus.Success) {
        this.userId = Number(data.content);
        this.router.navigateByUrl('/verification-code/' + this.userId + '/' + this.email);
      }
    }, error => {
      this._snackBarService.callSnackBar(error);
    });
  }
}
